module.exports = __webpack_public_path__ + "img/make_pc_01.6023a33f.png";